import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { DynamicsAXLinkedService } from 'app/model/linkedservice/dynamics-ax.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsAX.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.DynamicsAX_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.DynamicsAX_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: DynamicsAXLinkedService.MODEL // Linked service redefined
        }
    }
})
export class DynamicsAXResourceDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
